import { ReactElement } from 'react'
import { List, ResourceComponentProps } from 'react-admin'

import ListPagination from '../Pagination'

type CTListProps = ResourceComponentProps<any> & {
  children: ReactElement
  filters?: ReactElement
  bulkActionButtons?: boolean
}

const CTList = (props: CTListProps) => (
  <List {...props} pagination={<ListPagination />} perPage={25}>
    {props.children}
  </List>
)

export default CTList
